import { render, staticRenderFns } from "./MenDianPurchaseSalesFeiYongLuRu.vue?vue&type=template&id=8904b094&scoped=true&"
import script from "./MenDianPurchaseSalesFeiYongLuRu.vue?vue&type=script&lang=js&"
export * from "./MenDianPurchaseSalesFeiYongLuRu.vue?vue&type=script&lang=js&"
import style0 from "./MenDianPurchaseSalesFeiYongLuRu.vue?vue&type=style&index=0&id=8904b094&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8904b094",
  null
  
)

export default component.exports